import React, { useState, useEffect } from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { RoutableLink } from "../../react/RoutableLink";
import css from "./index.module.scss";

const QuickLinks = (props) => {
  var datasource = props.fields;
  var children = datasource.children;
  var tools = datasource.tools;
  const [showTools, setShowTools] = useState(
    datasource.showSavedTools?.value == true && datasource.tools?.length > 0
  );

  useEffect(() => {
    setShowTools(
      datasource.showSavedTools?.value == true && datasource.tools?.length > 0
    );
  });

  console.log(datasource?.savedToolsHeading?.value, 'sani');

  return (
    datasource && (
      <section
        className={`${css.container} ${
          datasource.useTextLinksWithNoIcons?.value
            ? css.linkLayout
            : css.buttonLayout
        } single-col-inner`}
      >
        {showTools && !props.sitecoreContext?.pageEditing && (
          <div className={datasource?.link?.value?.href && datasource?.linkText?.value && datasource?.savedToolsHeading?.value ? css.linkContainer : datasource?.link?.value?.href && datasource?.linkText?.value && !datasource?.savedToolsHeading?.value ? css.linkContainer1 : ''}>
            <Text
              field={datasource.savedToolsHeading}
              tag="h3"
              className={`${css.header} sans-head-3`}
            />
            {datasource?.link?.value?.href && datasource?.linkText?.value &&  (
             
              <RoutableLink field={datasource.link} data-chevron={true}>
                <Text field={datasource.linkText}></Text>
              </RoutableLink>
              
            )}
          </div>
        )}

        {(!showTools || props.sitecoreContext?.pageEditing == true) && (
         <div className={datasource?.link?.value?.href && datasource?.linkText?.value && datasource?.heading?.value ? css.linkContainer : datasource?.link?.value?.href && datasource?.linkText?.value && !datasource?.heading?.value ? css.linkContainer1 : ''}>
            <Text
              field={datasource.heading}
              tag="h3"
              className={`${css.header} sans-head-3`}
            />
            {datasource?.link?.value?.href && datasource?.linkText?.value &&   (
              
              <RoutableLink field={datasource.link} data-chevron={true}>
                <Text field={datasource.linkText}></Text>
              </RoutableLink>
              
            )}
          </div>
        )}

        <ul className={css.list}>
          {showTools && !props.sitecoreContext?.pageEditing
            ? tools.map(({ name, url, target, icon }, index) => {
                return (
                  <li key={`quickLink-${index}`} className={css.listItem}>
                    <a
                      href={url}
                      className={css.listItemLink}
                      data-chevron={true}
                      target={target}
                    >
                      {icon?.length > 0 && (
                        <i
                          className={`fa fa-${icon} ${css.listItemIcon}`}
                          style={{ marginRight: 10 }}
                        />
                      )}
                      <span>{name}</span>
                    </a>
                  </li>
                );
              })
            : children?.map(({ fields }, index) => {
                const { linkText, link, icon, ARIALabelText } = fields;
                return (
                  <li key={`quickLink-${index}`} className={css.listItem}>
                    <RoutableLink
                      field={link}
                      className={css.listItemLink}
                      data-chevron={true}
                      ariaLabel={ARIALabelText?.value || ""}
                    >
                      {icon?.value && (
                        <i
                          className={`fa fa-${icon.value} ${css.listItemIcon}`}
                        />
                      )}
                      <Text field={linkText} />
                    </RoutableLink>
                  </li>
                );
              })}
        </ul>
      </section>
    )
  );
};

export default withSitecoreContext()(QuickLinks);
